import { faCheckCircle, faCogs, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Dropdown, DropdownButton, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import "./InstanceTemplateInfoCard.css";

class InstanceTemplateInfoCard extends React.Component {
  constructor(props) {
    super(props);
    this.instanceFormatTypes = [
      "SingleInstanceTemplate.BasicInformation.VirtualComputer",
      "SingleInstanceTemplate.BasicInformation.Browser",
      "SingleInstanceTemplate.BasicInformation.Local"
    ];
    this.state = {};
  }

  softwareCatalogsToString(softwareCatalogs) {
    return softwareCatalogs.map(s => s.name).join(", ");
  }

  render() {
    const { t } = this.props;

    const body = (
      <>
        <Row className="pageTitle">
          <Col>
            <h2>{t("SingleInstanceTemplate.Title")}</h2>
          </Col>
          <Col>
            <div style={{ float: "right" }}>
              <DropdownButton
                onClick={event => event.stopPropagation()}
                id="dropdown-basic-button"
                title={<FontAwesomeIcon icon={faCogs} />}
                className="btn-green"
              >
                <Dropdown.Item onClick={this.props.onEdit}>
                  {t("SingleInstanceTemplate.ActionCell.EditOption")}
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <div>
              <b>{t("SingleInstanceTemplate.BasicInformation.Name")}:</b>{" "}
              {this.props.instanceTemplate.name}
            </div>
            <div>
              <b>{t("SingleInstanceTemplate.BasicInformation.IsPublished")}:</b>{" "}
              <FontAwesomeIcon
                className={
                  this.props.instanceTemplate.isPublished
                    ? "published"
                    : "not-published"
                }
                icon={
                  this.props.instanceTemplate.isPublished
                    ? faCheckCircle
                    : faTimesCircle
                }
              />
            </div>
            <div>
              <b>{t("SingleInstanceTemplate.BasicInformation.Tags")}:</b>{" "}
              {this.props.instanceTemplate.tags.join(", ")}
            </div>
          </Col>
          <Col style={{ borderLeft: "1px solid gray" }}>
            <div>
              <b>{t("SingleInstanceTemplate.BasicInformation.Type")}:</b>{" "}
              {t(this.instanceFormatTypes[this.props.instanceTemplate.type])}
            </div>
            <div>
              <b>
                {t(
                  "SingleInstanceTemplate.BasicInformation.PreferredNetworkProfile"
                )}
                :
              </b>{" "}
              {this.props.preferredNetworkProfile
                ? this.props.preferredNetworkProfile
                : t(
                  "SingleInstanceTemplate.BasicInformation.NoPreferredNetworkProfile"
                )}
            </div>
            <div>
              <b>
                {t("SingleInstanceTemplate.BasicInformation.SoftwareCatalogs")}:
              </b>{" "}
              {this.props.softwareCatalogs
                ? this.softwareCatalogsToString(this.props.softwareCatalogs)
                : t(
                  "SingleInstanceTemplate.BasicInformation.NoSoftwareCatalogs"
                )}
            </div>
          </Col>
        </Row>
      </>
    );

    return <div>{body}</div>;
  }
}

export default withTranslation()(InstanceTemplateInfoCard);
